import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material'
import { Button } from '@material-ui/core'
import {
  POLICY_TYPE_BIKE,
  POLICY_TYPE_BIKE_EXPIRY,
} from 'src/utils/constants/BuyPolicyBike'

const ChoosePolicy = (props) => {
  const { policyTypeChoosen, isPolicyExpired, setIsPolicyExpired, setPolicy } =
    props
  const classes = useStyles()

  const [isPolicyExpiredSection, setIsPolicyExpiredSection] = useState(false)

  const handleChoosePolicy = (policyTypeChoosen) => {
    setPolicy(policyTypeChoosen)
    setIsPolicyExpiredSection((prevState) => !prevState)
  }

  return (
    <Box>
      {isPolicyExpiredSection ? (
        <Box className={classes.policyExpiryContainer}>
          <Box className={classes.policyExpirySection}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby='policy-type-radio-label'
                name='policy-type-radio'
                value={
                  isPolicyExpired
                    ? POLICY_TYPE_BIKE_EXPIRY?.EXPIRED
                    : POLICY_TYPE_BIKE_EXPIRY?.NOT_EXPIRED
                }
                onChange={(event) => {
                  setIsPolicyExpired(
                    event.target.value === POLICY_TYPE_BIKE_EXPIRY?.EXPIRED
                      ? true
                      : false
                  )
                }}
              >
                <FormControlLabel
                  className={classes.formRadioText}
                  value={POLICY_TYPE_BIKE_EXPIRY?.NOT_EXPIRED}
                  control={
                    <Radio className={classes.radioBtnSelected} size='small' />
                  }
                  label={
                    <Box className={classes.RadioBtnText}>Not Expired</Box>
                  }
                />
                <FormControlLabel
                  className={classes.formRadioText}
                  value={POLICY_TYPE_BIKE_EXPIRY?.EXPIRED}
                  control={
                    <Radio className={classes.radioBtnSelected} size='small' />
                  }
                  label={<Box className={classes.RadioBtnText}>Expired</Box>}
                />
              </RadioGroup>
            </FormControl>
          </Box>
        </Box>
      ) : (
        <Button
          id='Button'
          className={`${
            policyTypeChoosen === POLICY_TYPE_BIKE?.COMPREHENSIVE
              ? classes.chooseBtnComprehensive
              : ''
          }${
            policyTypeChoosen === POLICY_TYPE_BIKE?.OWNDAMAGE
              ? classes.chooseBtnOwnDamage
              : ''
          }${
            policyTypeChoosen === POLICY_TYPE_BIKE?.THIRD_PARTY
              ? classes.chooseBtnThirdParty
              : ''
          }`}
          onClick={() => handleChoosePolicy(policyTypeChoosen)}
        >
          Choose
        </Button>
      )}
    </Box>
  )
}

export default ChoosePolicy

const useStyles = makeStyles({
  policyExpiryContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  policyExpirySection: {
    paddingTop: 20,
    paddingBottom: 10,
    paddingLeft: 15,
    paddingRight: 5,
    borderRadius: 10,
    background: '#FFFFFF',
    boxShadow: '0px 0px 10px 0px #00000066',
  },
  formRadioText: {
    marginTop: '-15px',
  },
  radioBtnSelected: {
    '& .MuiSvgIcon-root': {
      // color: '#44BFE0',
    },
  },
  RadioBtnText: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '19.55px',
    letterSpacing: '0em',
    marginLeft: '-7px',
  },
  chooseBtnThirdParty: {
    border: '1px solid #EF669B',
    color: '#EF669B',
  },
  chooseBtnComprehensive: {
    border: '1px solid #4DC3E3',
    color: '#4DC3E3',
  },
  chooseBtnOwnDamage: {
    border: '1px solid #9271BE',
    color: '#9271BE',
  },
})
